module.exports = __webpack_public_path__ + "static/media/portrait-kka.8d1a58bb.jpg";